import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import usePersistStoreData from "../../Components/Hooks/usePersistStoreData";
import TableContainerSearch2 from "../../Components/Common/TableContainerSearch2";
import TableContainer1 from "../../Components/Common/TableContainer1";
import axios from "axios";
import exportToPDF from "../../Components/Common/exportToPDF";
import TableContainerDateRangeFilter2 from "../../Components/Common/TableContainerDateRangeFilter2";
import exportToExcel from "../../Components/Common/exportToExcel";
import { useDispatch } from "react-redux";
import { showToast } from "../../Components/ToastNotification";
import { shareEmailReportThunk } from "../../slices/thunks";
import CommonLoading from "../../Components/Common/CommonLoading";
import { tableHeader2 as tableNew, columns } from "./FnOUtility";
import {
  adjustSelectedDateRange,
  adjustToWorkingDay,
  getCurrentFiscalYearDates,
} from "../../Components/Common/WorkingDateRange";

const FnO = () => {
  // document.title = "Dashboard | B.N. Rathi";

  const { userData } = usePersistStoreData();
  // console.log("userData", userData);
  const dispatch = useDispatch();
  const token = userData?.token;
  const [dateRange, setDateRange] = useState([]);
  const [rightColumn, setRightColumn] = useState(true);
  const toggleRightColumn = () => {
    setRightColumn(!rightColumn);
  };
  const [isTopPageDropdown, setTopPageDropdown] = useState(false);
  const toggleDropdown = () => {
    setTopPageDropdown(!isTopPageDropdown);
  };

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [expense, setExpense] = useState(null);
  const [loading, setLoading] = useState(false);
  const [expenseLoading, setExpenseLoading] = useState(false);
  const [error, setError] = useState(null);
  const [globalFilter, setGlobalFilter] = useState("");

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleShareEmail = async () => {
    let startDate, endDate;

    if (dateRange && dateRange.length === 2) {
      const { adjustedStart, adjustedEnd } = adjustSelectedDateRange(
        dateRange[0],
        dateRange[1]
      );
      startDate = formatDate(adjustedStart);
      endDate = formatDate(adjustedEnd);
    } else {
      const today = new Date();

     
      const defaultEnd = new Date(today);
     

      // Retrieve the current fiscal year start and adjust using "start" logic.
      const { fyStart } = getCurrentFiscalYearDates();
      const defaultStart = adjustToWorkingDay(new Date(fyStart), "start");

      startDate = formatDate(defaultStart);
      endDate = formatDate(defaultEnd);
    }
    const body = {
      report_type: "positions",
      "additional_data[position_type]": "net",
      "additional_data[segment]": "FO",
      "additional_data[start_date]": startDate,
      "additional_data[end_date]": endDate,
    };

    try {
      const response = await dispatch(
        shareEmailReportThunk({ body, token })
      ).unwrap();

      showToast("Report sent on your email successfully", "success");
    } catch (error) {
      console.error("Error submitting request:", error);
      showToast(
        error?.message || "Something went wrong, please try again",
        "error"
      );
    }
  };

  useEffect(() => {
    const fetchHoldings = async () => {
      setLoading(true);
      setError(null);
      const today = new Date();

      // Compute T-1 (yesterday) and adjust to a working day (using "end" logic)
      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      // yesterday = adjustToWorkingDay(yesterday, "end");

      // Get the fiscal year start date and adjust it to a working day (using "start" logic)
      const { fyStart } = getCurrentFiscalYearDates();
      const startDate = adjustToWorkingDay(new Date(fyStart), "start");
      try {
        const response = await axios.get("net-positions", {
          params: {
            segment: "FO",
            // start_date: formatDate(startDate),
            // end_date: formatDate(yesterday),
          }, // Pass holdingType as query param
          headers: {
            Authorization: `Bearer ${userData?.token}`, // Add Authorization header
            "Content-Type": "application/json",
          },
        });
        setExpense(response?.data?.expenses);
        setSummary(response?.data?.summary);
        // console.log("here", response, response.data?.summary);
        setData(response.data?.items); // Update state with fetched data
        // setTimeout(() => {
        setLoading(false);
        // }, 2000);
      } catch (err) {
        console.error("Error fetching holdings:", err);
        // setSummary(null)
        setError(err);
        setLoading(false);
      } finally {
        // setSummary(null)
        setLoading(false);
      }
    };

    fetchHoldings();
  }, []); // Runs when holdingType or token changes

  const handleDateRangeChange = async (values) => {
    // console.log("values",values)
    // setLoading(true);
    setError(null);
    setExpenseLoading(true);
    // const holdingType = 1;
    try {
      const { adjustedStart, adjustedEnd } = adjustSelectedDateRange(
        values.start_date,
        values.end_date
      );
      const response = await axios.get("net-positions", {
        params: {
          segment: "FO",
          // start_date: formatDate(adjustedStart),
          // end_date: formatDate(adjustedEnd),
        }, // Pass holdingType as query param
        headers: {
          Authorization: `Bearer ${userData?.token}`, // Add Authorization header
          "Content-Type": "application/json",
        },
      });

      // console.log("here", response);
      setExpense(response?.data?.expenses);
      setSummary(response.data?.summary);
      setData(response.data?.items); // Update state with fetched data
      // setTimeout(() => {
      values.setTableLoading(false);
      setExpenseLoading(false);
      // }, 2000);
    } catch (err) {
      console.error("Error fetching holdings:", err);
      // setSummary(null)
      setError(err);
      values.setTableLoading(false);
      setExpenseLoading(false);
    } finally {
      values.setTableLoading(false);
      setExpenseLoading(false);
      // setSummary(null)
    }
  };

  const tableHeaders = columns.map((col) => col.Header.replace(/₹/g, "Rs"));
  const tableHeader2 = tableNew.map((col) => col.Header.replace(/₹/g, "Rs"));

  const tableBody = data.map(
    (row) =>
      columns.map((col) =>
        row[col.accessorKey]
          ? typeof row[col.accessorKey] === "string"
            ? row[col.accessorKey]
            : row[col.accessorKey].toLocaleString("en-IN")
          : 0
      ) // Default to 0 if value is missing
  );

  const tableBody2 = [
    [
      parseFloat(expense?.pay_in_pay_out ?? 0).toLocaleString("en-IN"),
      parseFloat(expense?.total_gst ?? 0).toLocaleString("en-IN"),
      parseFloat(expense?.turn_tax ?? 0).toLocaleString("en-IN"),
      parseFloat(expense?.min_brokerage ?? 0).toLocaleString("en-IN"),
      parseFloat(expense?.exchange_charges ?? 0).toLocaleString("en-IN"),
      parseFloat(expense?.stamp ?? 0).toLocaleString("en-IN"),
      parseFloat(expense?.stt ?? 0).toLocaleString("en-IN"),
      parseFloat(expense?.sebi_tax ?? 0).toLocaleString("en-IN"),
      parseFloat(expense?.ipf_charges ?? 0).toLocaleString("en-IN"),
      parseFloat(expense?.clearing_charges ?? 0).toLocaleString("en-IN"),
      parseFloat(expense?.total_net ?? 0).toLocaleString("en-IN"),
    ],
  ];

  // Define which columns to sum
  const sumColumns = [
    "buy_qty",
    "buy_value",
    "sell_qty",
    "sell_value",
    "net_qty",
    "net_value",
    "pnl",
  ];
  // Example API response for totals
  const apiTotals = {
    buy_qty: summary?.total_buy_qty, // Replace with actual API data
    buy_value: summary?.total_buy_value, // Replace with actual API data
    sell_qty: summary?.total_sell_qty,
    sell_value: summary?.total_sell_value,
    net_qty: summary?.total_net_qty,
    net_value: summary?.total_net_value,
    pnl: summary?.total_pnl,
  };

  // Columns to sum (coming from user-defined array)
  // const sumColumns = ["debit", "credit"];

  // Insert API totals only for "debit" and "credit"
  const totals = columns.map((col, index) => {
    if (index === 0) return "TOTAL"; // First column will have "Total"

    return sumColumns.includes(col.accessorKey)
      ? apiTotals[col.accessorKey]?.toLocaleString("en-IN") || 0 // Use API total, default to 0 if missing
      : ""; // Leave other columns empty
  });

  // Add totals row to the ta
  tableBody.push(totals);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {loading ? (
            <div
              className="centerContent h-100 w-100"
              style={{ minHeight: "80vh" }}
            >
              <CommonLoading />
            </div>
          ) : (
            <>
              <Card className="mb-6">
                <CardHeader>
                  <div className="m-0 p-0 d-flex align-items-center justify-content-between flex-wrap">
                    <div className="d-flex flex-column mb-2 mb-md-0">
                      <h3 className="m-0">Net Position - F&O</h3>
                      <p className="mb-0 mt-1 fs-14 fw-medium text-muted">
                        As on Date: {summary?.end}
                      </p>
                    </div>
                    <div className="d-flex flex-wrap justify-content-start justify-content-md-center ">
                      <div className="search-box   me-2 ">
                        <input
                          id="search-bar-0"
                          type="text"
                          style={{
                            backgroundColor: "#F1F4F7",
                            paddingTop: ".6rem",
                            paddingBottom: ".6rem",
                          }}
                          className="form-control border-0 search "
                          placeholder="Search by instrument"
                          value={globalFilter}
                          onChange={(e) => setGlobalFilter(e.target.value)}
                        />
                        <i className="bx bx-search-alt search-icon-new"></i>
                      </div>
                      <Dropdown
                        isOpen={isTopPageDropdown}
                        toggle={toggleDropdown}
                        className={`card-header-dropdown ${
                          data.length === 0 && expense === null
                            ? "disabled-dropdown_export"
                            : ""
                        }`}
                      >
                        <DropdownToggle
                          tag="a"
                          className="text-reset dropdown-btn "
                          role="button"
                          color="success"
                        >
                          <Button
                            type="button"
                            color="success"
                            className=" export_btn_new"
                          >
                            Export<i className="ms-1 bx bx-caret-down"></i>
                          </Button>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                          <DropdownItem
                            onClick={() =>
                              exportToPDF(
                                "Net Position - F&O",
                                userData,
                                `Combined`,
                                `From: ${summary?.start} - To: ${summary?.end}`,
                                tableHeaders,
                                tableBody,
                                tableHeader2,
                                tableBody2,
                                "Expense Details"
                              )
                            }
                          >
                            Export as PDF
                          </DropdownItem>
                          <DropdownItem
                            onClick={() =>
                              exportToExcel(
                                "Net Position - F&O",
                                userData,
                                `Combined`,
                                `From: ${summary?.start} - To: ${summary?.end}`,
                                tableHeaders,
                                tableBody,
                                "Expense Details",
                                tableHeader2,
                                tableBody2
                              )
                            }
                          >
                            Export Excel
                          </DropdownItem>
                          <DropdownItem onClick={handleShareEmail}>
                            Share on Email
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </div>
                </CardHeader>
                <CardBody>
                  <TableContainerDateRangeFilter2
                    footer={true}
                    type="FO"
                    summary={summary}
                    columns={columns}
                    data={data}
                    onDateRangeChange={handleDateRangeChange}
                    dateRange={dateRange}
                    setDateRange={setDateRange}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                  />
                </CardBody>
              </Card>
              {!expenseLoading && (
                <Card className="mb-6">
                  <CardHeader>
                    <div className="m-0 p-0 d-flex align-items-center justify-content-between">
                      <h3 className="m-0">Expense Details</h3>
                    </div>
                  </CardHeader>
                  <CardBody>
                    <div className="table-responsive">
                      <Table
                        hover
                        className="align-middle table-nowrap table-bordered"
                      >
                        <thead className={`bg-gl-primary sticky-header`}>
                          <tr>
                            <th className="text-end">Pay In/ Pay Out (₹)</th>
                            <th className="text-end">Total GST (₹)</th>
                            <th className="text-end">Turn. Tax (₹)</th>
                            {/* <th className="text-end">Fut. MTM (₹)</th> */}
                            <th className="text-end">Clearing Charges (₹)</th>
                            <th className="text-end">Min. Brok. (₹)</th>
                            <th className="text-end">Exch. Charges (₹)</th>
                            <th className="text-end">Stamp Duty Charges (₹)</th>
                            <th className="text-end">STT (₹)</th>
                            <th className="text-end">Sebi Tax (₹)</th>
                            <th className="text-end">IPF Charges (₹)</th>
                            {/* <th className="text-end">Total Premium (₹)</th> */}

                            <th className="text-end">Net (₹)</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td className="fs-p-bg fw-medium text-end">
                              {parseFloat(
                                expense?.pay_in_pay_out ?? 0
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td className="fs-p-bg fw-medium text-end">
                              {parseFloat(
                                expense?.total_gst ?? 0
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td className="fs-p-bg fw-medium text-end">
                              {parseFloat(
                                expense?.turn_tax ?? 0
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td className="fs-p-bg fw-medium text-end">
                              {parseFloat(
                                expense?.clearing_charges ?? 0
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td className="fs-p-bg fw-medium text-end">
                              {parseFloat(
                                expense?.min_brokerage ?? 0
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td className="fs-p-bg fw-medium text-end">
                              {parseFloat(
                                expense?.exchange_charges ?? 0
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td className="fs-p-bg fw-medium text-end">
                              {parseFloat(expense?.stamp ?? 0).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                            </td>
                            <td className="fs-p-bg fw-medium text-end">
                              {parseFloat(expense?.stt ?? 0).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                            </td>
                            <td className="fs-p-bg fw-medium text-end">
                              {parseFloat(
                                expense?.sebi_tax ?? 0
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td className="fs-p-bg fw-medium text-end">
                              {parseFloat(
                                expense?.ipf_charges ?? 0
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            {/* <td className="fs-p-bg fw-medium text-end">
                              {parseFloat(
                                expense?.total_premium ?? 0
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td> */}
                            {/* <td className="fs-p-bg fw-medium text-end">
                            {parseFloat(
                              expense?.clearing_charges ?? 0
                            ).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                              })}
                          </td> */}

                            <td className="fs-p-bg fw-medium text-end">
                              {parseFloat(
                                expense?.total_net ?? 0
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              )}
            </>
          )}
          {/* <BreadCrumb title="Dashboard" pageTitle="Dashboards" /> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FnO;
